import React from 'react';
import { Box, Typography } from '@mui/material';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { useNavigate } from 'react-router-dom';
import { useStatusPalette } from '../../utils/statusColors';
import { buildAgentChatUrl } from './boards/commentUtils';

/**
 * "Connected session" row shown in the scheduled-message and recurring-schedule detail dialogs.
 * A schedule wakes its originating chat session (never a new one), so this deep-links to that
 * conversation. Renders nothing when the schedule has no agent/session (e.g. legacy targets).
 */
export default function ScheduleSessionLink({ agentId, chatSessionId, onNavigate }) {
  const _sp = useStatusPalette();
  const navigate = useNavigate();

  if (!agentId || !chatSessionId) return null;

  const handleClick = () => {
    if (onNavigate) onNavigate();
    navigate(buildAgentChatUrl(agentId, chatSessionId));
  };

  return (
    <>
      <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'text.primary', mb: 0.75 }}>
        Connected session
      </Typography>
      <Box
        onClick={handleClick}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          mb: 1,
          px: 0.5,
          cursor: 'pointer',
          color: _sp.blue.color,
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        <OpenInNewOutlinedIcon sx={{ fontSize: 15 }} />
        <Typography sx={{ fontSize: '13px', fontWeight: 500, color: 'inherit' }}>
          View conversation
        </Typography>
      </Box>
    </>
  );
}
